var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"columns is-multiline is-mobile"},_vm._l((_setup.props.images),function(src,index){return _c('div',{key:index,staticClass:"column is-half"},[_c(_setup.SelectableImage,{attrs:{"disabled":_vm.disabled,"index":index,"src":src},on:{"click":function($event){return _setup.handleClick(index)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }